// extracted by mini-css-extract-plugin
export default {"newInBoxTitle":"JIjSC","newInBoxDescription":"outxu","newInBoxText":"HKWoq"};